import _ from 'lodash';

const lowerThan = (value, item) => {
  if (!_.isEmpty(value)) {
    return +value > +item;
  }
  return true;
};

const upperThan = (value, item) => {
  if (!_.isEmpty(value)) {
    return +value < +item;
  }
  return true;
};

const filterAmenity = (hotel_amity, option_list) => {
  if (_.isEmpty(option_list)) {
    return true;
  }
  if (option_list.length === 0) {
    return true;
  }
  const amenitiesId = _.map(hotel_amity, (amenity) => amenity.id);
  const result = _.difference(option_list, amenitiesId);
  return result.length === 0;
};

const filterRating = (start_rating, option_list) => {
  if (_.isEmpty(option_list)) {
    return true;
  }
  if (option_list.length === 0) {
    return true;
  }
  const res = !!_.find(option_list, (item) => {
    return +item <= +start_rating && +start_rating < +item + 1;
  });
  return res;
};
export const pagination = (filteredList, page) => {
  return _.drop(filteredList, (page - 1) * 20).slice(0, 20);
};

export const filterList = (list, filter) => {
  return _.filter(list, (hotel) => {
    return (
      lowerThan(filter.budgetEnd, hotel.price_saving) &&
      upperThan(filter.budgetStart, hotel.price_saving) &&
      filterAmenity(hotel.amenity_data, filter.amenities) &&
      filterRating(hotel.star_rating, filter.rating) &&
      (_.isEmpty(filter.hotelName) || hotel.name.toLowerCase().indexOf(filter.hotelName) >= 0)
    );
  });
};

export const getChainList = (hotels_list, hotelChain) => {
  const chainList = {};
  let selectedChain = hotelChain;
  if (!_.isUndefined(hotelChain) && !_.isArray(hotelChain)) {
    selectedChain = hotelChain.split(',');
  }
  hotels_list.forEach((item) => {
    if (!_.isNull(item.hotel_chain_name)) {
      if (_.has(chainList, item.hotel_chain_id)) {
        chainList[item.hotel_chain_id].count += 1;
      } else {
        chainList[item.hotel_chain_id] = {
          name: item.hotel_chain_name,
          count: 1,
          check: !!_.includes(selectedChain, item.hotel_chain_id),
          id: item.hotel_chain_id,
        };
      }
    }
  });
  return chainList;
};

export const getStarList = (hotels_list) => {
  const starList = {};
  hotels_list.forEach((item) => {
    const star = Math.floor(item.star_rating);
    if (star !== null) {
      if (starList[star] !== undefined) {
        starList[star] += 1;
      } else {
        starList[star] = 1;
      }
    }
  });
  return starList;
};

// sorting hotels
export const sortHotels = (hotels_list, sortBy) => {
  let sorted_hotels = [];
  switch (sortBy) {
    case 'Percent Savings':
      // sorting by rate
      sorted_hotels = hotels_list.sort((a, b) => {
        return b.price_saving_percentage - a.price_saving_percentage;
      });
      break;
    case 'Price - High to Low':
      // sorting by high to low
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.price_saving) - Number(a.price_saving);
      });
      break;
    case 'Price - Low to High':
      // sorting by rate low to high
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(a.price_saving) - Number(b.price_saving);
      });
      break;
    case 'Star Rating':
      // sorting by star rating
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.star_rating) - Number(a.star_rating);
      });
      break;
    case 'Select Custom 2':
      // sorting by star rating
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.select_custom_sort_percentage) - Number(a.select_custom_sort_percentage);
      });
      break;
    case 'Benefit Amount':
      // sorting by star rating
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.select_sort_amount) - Number(a.select_sort_amount);
      });
      break;
    case 'Select Custom 1':
      // sorting by star rating
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.select_custom_sort_amount) - Number(a.select_custom_sort_amount);
      });
      break;
    default:
      // sorting by rate
      sorted_hotels = hotels_list.sort((a, b) => {
        return Number(b.select_custom_sort_amount) - Number(a.select_custom_sort_amount);
      });
  }
  return sorted_hotels;
};
